





















































import Vue from 'vue';

// Firebase
import firebase from 'firebase/app';
import 'firebase/auth';

export default Vue.extend({
	name: 'Login',

	data: () => ({
		email: '',
		password: '',
		error: '',
		footyLogo: require('@/assets/images/footy_logo_dark.png'),
	}),

	methods: {
		async login() {
			this.error = '';
			// Log in user
			const user = await firebase
				.auth()
				.signInWithEmailAndPassword(this.email, this.password)
				.catch(error => {
					const errorCode = error.code;
					const errorMessage = error.message;
					this.error = errorMessage;
				});
		},
	},
});
